module.exports = __webpack_public_path__ + "media/images/client-logos/client-logo_massmutual-130200f39aa5a8b55eccbeb919e1acaf.svg";